import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { BaseStore } from '../base/base.store';
import { AppTokenService } from '../../../app-token.service';

@Injectable({
    providedIn: 'root'
})
@StoreConfig({
    name: AppTokenService.PAGE_SCHEMA_NAME,
    cache: {
        ttl: 15000
    }
})
export class PageStore extends BaseStore {

    constructor() {
        super();
    }
}
